import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { V2ErrorResponseSchema } from "../../actions";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../../services/analytics/tracking";

export interface OnboardingPayload {
  appname: string;
  tenantType: string; // "b2b" | "b2c"
}

export interface OnboardingResult extends V2ErrorResponseSchema {
  app_name?: string;
  app_id?: string;
}

export interface OnboardingState extends MutationTrackingState {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorMessage: string | null;
}

const initialState: OnboardingState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: null
};

export const OnboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    onboardingRequest(state, action: PayloadAction<OnboardingPayload>) {
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = null;
      Object.assign(state, getRequestTrackingState(action));
    },
    onboardingSuccess(state) {
      state.isLoading = false;
      state.isSuccess = true;
      Object.assign(state, getOutcomeTrackingState(state, "success"));
    },
    onboardingFailure(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.payload;
      Object.assign(state, getOutcomeTrackingState(state, "error"));
    }
  }
});

export const { onboardingRequest, onboardingSuccess, onboardingFailure } = OnboardingSlice.actions;
export default OnboardingSlice.reducer;
